import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationCreateRoute: InvariantJiraRoute = {
	name: 'eoc-team-integration-create',
	path: '/jira/ops/teams/:teamId/integrations/create/:type',
	exact: true,
};
